import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47c1ce5f"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "reset-password-sent-text-style"
}, " Sorry! But this page is not exists. ", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "reset-password-sent-text-style"
}, " Check the URL or go to Home page. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  const _component_the_wrapper_public = _resolveComponent("the-wrapper-public");
  return _openBlock(), _createBlock(_component_the_wrapper_public, {
    title: "Page Not Found",
    scrollable: false
  }, {
    default: _withCtx(() => [_hoisted_1, _hoisted_2, _createVNode(_component_app_button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
    }, {
      default: _withCtx(() => [_createTextVNode(" Go to Home page ")]),
      _: 1
    })]),
    _: 1
  });
}